import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { capitalize } from '@ember/string';
import Component from '@glimmer/component';

import moment from 'moment';

import type { Service } from 'webapp-types';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export default class AppNotificationsPromotionsGrowth2024DiscountComponent extends Component {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('flow/promotions')
	declare flowPromotionsService: Service.Flow.Promotions;
	@service('billing') declare billingService: Service.Billing;
	@service('user-settings') declare userSettingsService: Service.UserSettings;

	get promotion() {
		return this.flowPromotionsService.promotions.growthPlanDiscountOptionPromotion;
	}

	get isProfessional() {
		return this.billingService.activePlan?.isProfessional;
	}

	get timeLeftText() {
		return capitalize(this.promotion?.timeLeftText || '');
	}

	@action
	claim() {
		this.flowPromotionsService.openGrowthPromoUpgradePopup('promote_growth_plan_top_banner');
	}

	@action
	snooze() {
		void this.userSettingsService.save(
			UserSettingsKey.PROMOTION_GROWTH_2024_BANNER_DISCOUNT_SNOOZE_TIMESTAMP,
			moment().add(30, 'days').unix(),
		);
	}
	<template>
		<div class="notification-container promotions-growth-2024-discount-notification">
			<div class="container">
				<p>
					{{#if this.isProfessional}}
						<CommonUiIconComponent @name="Gift" @size="sm" />
						Upgrade to
						<b>Growth plan</b>
						today and save
						<b>
							{{this.promotion.totalDiscountAmmountFormatted}}
							within first
							{{this.promotion.discountDurationInMonths}}
							months.
							{{this.timeLeftText}}
						</b>
						remaining to claim the offer.
					{{else}}
						<CommonUiIconComponent @name="Gift" @size="sm" />
						Upgrade to
						<b>Growth</b>
						and enjoy
						<b>
							{{this.promotion.totalDiscountAmmountFormatted}}
							off within first
							{{this.promotion.discountDurationInMonths}}
							months
						</b>
					{{/if}}
					<div class="actions">
						<a class="button size-small" {{on "click" this.claim}}>
							{{#if this.isProfessional}}Upgrade now{{else}}Claim discount now{{/if}}
						</a>
						{{#unless this.isProfessional}}
							<a
								class="button theme-blue-outlined size-small"
								{{on "click" this.snooze}}
							>
								Snooze offer
							</a>
						{{/unless}}
					</div>
				</p>
			</div>
		</div>
	</template>
}
